import { BaseService, NOME_TOKEN_ACESSO_DIRETO } from '@thema/base-servicos'

const urlAdministracao = '/service/basico/administracao/'
class AdministracaoService extends BaseService {
    constructor() {
        const config = JSON.parse(sessionStorage.getItem('config'))
        super(NOME_TOKEN_ACESSO_DIRETO, config)
        const adms = config.adms ? config.adms : []
        this.state = {
            adms: adms,
        }
    }

    getAdministracao() {
        let data = { codigo: this.state.adms }
        return this.conex.post(urlAdministracao + 'administracoesPermitidas/', JSON.stringify(data))
    }

    getTodasAdministracoes() {
        return this.conex.get(urlAdministracao + 'listaAdministracoes/')
    }
}

export default AdministracaoService
